import { SEPARATOR_CONTAINS_REGEX, SEPARATOR_JOIN_TEXT, SEPARATOR_SPLIT_PATTERN } from './constants.js';
import { CreatableListValueSeparator } from './types.js';
const buildSplitRegex = (separators) => {
    const patterns = separators.map((separator) => SEPARATOR_SPLIT_PATTERN[separator]);
    return new RegExp(patterns.join('|'));
};
export const splitBySeparators = (text, separators) => {
    if (separators.length === 0) {
        return text.trim() ? [text.trim()] : [];
    }
    return text
        .split(buildSplitRegex(separators))
        .map((s) => s.trim())
        .filter(Boolean);
};
export const containsSeparator = (text, separators) => separators.some((separator) => SEPARATOR_CONTAINS_REGEX[separator].test(text));
/** The fragment after the last separator: the value the user is typing right now. */
export const getLastFragment = (text, separators) => {
    if (separators.length === 0) {
        return text.trim();
    }
    const fragments = text.split(buildSplitRegex(separators));
    return fragments[fragments.length - 1]?.trim() ?? '';
};
/**
 * Appends an item to the typed text, joined by the first separator, and ends the text with that separator so the
 * next item can be typed straight away. The typed text is kept as it is.
 */
export const appendItem = (text, item, separators) => {
    // The component always passes at least one separator; the comma only satisfies the index type.
    const joinText = SEPARATOR_JOIN_TEXT[separators[0] ?? CreatableListValueSeparator.COMMA];
    const head = getLastFragment(text, separators) ? `${text.trimEnd()}${joinText}` : text;
    return `${head}${item}${joinText}`;
};
